import React from 'react'
import { Box } from '@workwhile/ui'
import { CompumaticClockPunchesFilters } from './CompumaticClockPunchesFilters'
import { CompumaticClockPunchesHeader } from './CompumaticClockPunchesHeader'
import { CompumaticClockPunchesTable } from './CompumaticClockPunchesTable'

export const CompumaticClockPunchesMain = () => {
  return (
    <>
      <CompumaticClockPunchesHeader />
      <Box margin={3}>
        <CompumaticClockPunchesFilters />
        <CompumaticClockPunchesTable />
      </Box>
    </>
  )
}
